import React from "react";
import "./builderHeader.css";

import BuilderBackButton from "./BuilderBackButton";

export default function BuilderHeader(props) {
  const {
    handleBackButton,
    isCustomizingCoa,
  } = props;

  return (
    <div className="templateBuilderHeader">
      <BuilderBackButton handleBackButton={handleBackButton} isCustomizingCoa={isCustomizingCoa} />
    </div>
  );
}
